import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { get } from 'lodash';
import { ICellRendererParams } from 'ag-grid-community';
import { AgRendererComponent } from 'ag-grid-angular';
import { BaseRendererComponent } from '../base-renderer.component';

@Component({
  selector: 'xea-popover-table-cell-renderer',
  templateUrl: 'popover-table-cell-renderer.component.html',
  styleUrls: ['./popover-table-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class XEAPopoverTableCellRendererComponent
  extends BaseRendererComponent
  implements AgRendererComponent
{
  @ViewChild('divElement', { static: false }) public divElement: ElementRef;

  public params: ICellRendererParams;
  public value: string;
  public popoverParentNode: string;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = get(this.params, 'value');
    this.popoverParentNode = get(this.params, 'popoverParentNode');
  }

  public refresh(): boolean {
    return false;
  }
}
